export default "__VITE_ASSET__yEJvZHK$__"